import EventHandler from "../../utils/dom/event-handler";
import SelectorEngine from "../../utils/dom/selector-engine";
import Request, { ApiMode } from "../../utils/request";
import Manipulator from "../../utils/dom/manipulator";
import {
	startLoadingAnimation,
	stopLoadingAnimation,
} from "../../utils/dom/loading";

const SELECTOR_WRAPPER = ".p-park-activator-training";
const SELECTOR_CARD = ".p-park-activator-training--card";
const SELECTOR_CARD_BUTTOn = ".p-park-activator-training--card-button";
const CLICK_EVENT = "click";

const IS_LOCAL = false;
class ParkActivatorTrainingCheck {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.parkActivatorTrainingCard = SelectorEngine.findOne(
			SELECTOR_CARD,
			this._wrapper
		);

		this.parkActivatorTrainingCardButton = SelectorEngine.findOne(
			SELECTOR_CARD_BUTTOn,
			this.parkActivatorTrainingCard
		);

		this.redirectURL = Manipulator.getDataAttribute(
			this.parkActivatorTrainingCardButton,
			"redirectUrl"
		);

		EventHandler.on(
			this.parkActivatorTrainingCardButton,
			CLICK_EVENT,
			() => {
				this.loadTraining();
		});
	}

	async loadTraining() {
		startLoadingAnimation();
		try {
			const url = "/api/parksactivators/EnrolledToSafeguarding";
			const response = await Request.post(url, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError,
				},
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();
			if (Success || success) {
				window.open(`${this.redirectURL}`, '_blank');
				location.reload();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
}

const globalParkActivatorTrainingCheck = new ParkActivatorTrainingCheck();
export default globalParkActivatorTrainingCheck;
